import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=210a7cc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210a7cc9"]])

export default __exports__